<template>
  <div class="text-center my-3">
    <h2>Please login</h2>
  </div>
</template>

<script>
export default {
  name: "LoginView"
};
</script>

<style>
</style>
